// to prevent displaying label for each item in array fields
function endsWithUnderscoreNumber(str: string) {
  return /_+\d+$/.test(str);
}

export const CustomFieldTemplate = (props: any) => {
  const { id, classNames, style, label, help, required, errors, children } =
    props;
  return (
    <div className={classNames} style={style}>
      <div style={{ display: "flex" }}>
        {!(
          id === "root" ||
          endsWithUnderscoreNumber(id) ||
          props.schema.type === "boolean" ||
          (props.schema.type === "array" &&
            props.schema.items?.type === "object")
        ) ? (
          <label
            htmlFor={id}
            className="pulse-typography-body-1 pulse-color--background-50"
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "2.5px",
            }}
          >
            {label}
            {required ? "*" : null}
          </label>
        ) : null}
      </div>
      <div onWheel={(e) => (e.target as HTMLElement).blur()}>{children}</div>

      <div className="pulse-color--error-500 pulse-typography-body-2">
        {errors}
      </div>
      {help}
    </div>
  );
};
